module.exports = __webpack_public_path__ + "img/0.859c9cac.png";